import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import WaitlistManager from './components/WaitlistManager';
import TemplateManager from './components/TemplateManager';
import SiteAnalytics from './components/SiteAnalytics';
import UserManager from './components/UserManager';
import LedgerManager from './components/LedgerManager';
import BusinessLookup from './components/BusinessLookup';
import TestRunner from './components/TestRunner';
import AIOpsConfig from './components/AIOpsConfig';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/waitlist" element={
              <ProtectedRoute>
                <WaitlistManager />
              </ProtectedRoute>
            } />
            <Route path="/templates" element={
              <ProtectedRoute>
                <TemplateManager />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute>
                <SiteAnalytics />
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute>
                <UserManager />
              </ProtectedRoute>
            } />
            <Route path="/ledger" element={
              <ProtectedRoute>
                <LedgerManager />
              </ProtectedRoute>
            } />
            <Route path="/lookup" element={
              <ProtectedRoute>
                <BusinessLookup />
              </ProtectedRoute>
            } />
            <Route path="/tests" element={
              <ProtectedRoute>
                <TestRunner />
              </ProtectedRoute>
            } />
            <Route path="/aiops" element={
              <ProtectedRoute>
                <AIOpsConfig />
              </ProtectedRoute>
            } />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;